import { IAbstractInitialState } from "../../types/common";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { TArtist, TArtistsCard } from "../../types/artists";
import { artistCard } from "../../api/asyncThuncks/artistsCards";
import { addRemoveLike } from "../../api/asyncThuncks/audioTracks";
import {addRemoveContestsLike} from "../../api/asyncThuncks/contestsCards";

interface IInitialState extends IAbstractInitialState {
  artists: TArtistsCard[];
  artistById: TArtist | null;
}

const initialState: IInitialState = {
  loading: "idle",
  artists: [],
  artistById: null,
  error: "",
};

const artistsSlice = createSlice({
  name: "artistsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(artistCard.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(artistCard.fulfilled, (state, { payload }) => {
        state.loading = "idle";
        state.artistById = { ...payload };
      })
      .addCase(artistCard.rejected, (state, { error }) => {
        if (error.message) state.error = error.message;
        state.loading = "failed";
      })
        .addCase(addRemoveLike.pending, (state, { meta: { arg: { id } } }) => {
          state.loading = "pending";
          if (state.artistById) {
            state.artistById = {
              ...state.artistById,
              audioTracks: state.artistById.audioTracks.map((audioTrack) => {
                if (audioTrack.id === id) {
                  audioTrack.isLiked = !audioTrack.isLiked;
                  audioTrack.likes = audioTrack.isLiked ? audioTrack.likes + 1 : audioTrack.likes - 1;
                }
                return audioTrack;
              }),
            };
          }
        })
        .addCase(addRemoveLike.fulfilled, (state) => {
          state.loading = 'idle';
        })
        .addCase(addRemoveLike.rejected, (state, { meta: { arg: { id } } }) => {
          state.loading = 'failed';
          if (state.artistById) {
            state.artistById = {
              ...state.artistById,
              audioTracks: state.artistById.audioTracks.map((audioTrack) => {
                if (audioTrack.id === id) {
                  audioTrack.isLiked = false;
                  audioTrack.likes -= 1;
                }
                return audioTrack;
              }),
            };
          }
        });

  },
});

export const selectArtists = (state: RootState): IInitialState => state.artists;

export default artistsSlice.reducer;
